// extracted by mini-css-extract-plugin
export default {"audioContainer":"_2McXTwg1","audioimage":"FmiqQYcV","audioTitle":"_2e8SgSP2","audioDescription":"HxKZlK76","audioThumbnailsContainer":"KNn4nn0O","descriptionContainer":"BdasxXYO"};